module.exports = __webpack_public_path__ + "media/images/childcare/yamina@2x-95f6d8a4adad770a0afa6be59b6d0748.jpg";